import { render } from "./FeedView.vue?vue&type=template&id=6854007a&scoped=true"
import script from "./FeedView.vue?vue&type=script&lang=js"
export * from "./FeedView.vue?vue&type=script&lang=js"

import "./FeedView.vue?vue&type=style&index=0&id=6854007a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6854007a"]])

export default __exports__